import * as React from "react";
import styles from "./GrayedBox.scss";

export const GrayedBox = ({ children }: React.PropsWithChildren<unknown>) => {
  return <div className={styles.GrayedBox}>{children}</div>;
};
